import { render, staticRenderFns } from "./index.vue?vue&type=template&id=95dc789e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95dc789e')) {
      api.createRecord('95dc789e', component.options)
    } else {
      api.reload('95dc789e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=95dc789e", function () {
      api.rerender('95dc789e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SensitiveImages/index.vue"
export default component.exports